// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reading-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--bg-tertiary);
  z-index: 999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-primary), var(--accent-hover));
  transition: width 0.3s ease-out;
  box-shadow: 0 0 12px var(--accent-primary);
}

/* Subtle animation when reaching end */
.progress-fill:last-child {
  animation: glow 0.6s ease-out;
}

@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 12px var(--accent-primary);
  }
  50% {
    box-shadow: 0 0 24px var(--accent-primary);
  }
}

/* Mobile - slightly thicker for easier tap target awareness */
@media (max-width: 768px) {
  .reading-progress-bar {
    height: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReadingProgressBar/ReadingProgressBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,8EAA8E;EAC9E,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".reading-progress-bar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 3px;\r\n  background: var(--bg-tertiary);\r\n  z-index: 999;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, var(--accent-primary), var(--accent-hover));\r\n  transition: width 0.3s ease-out;\r\n  box-shadow: 0 0 12px var(--accent-primary);\r\n}\r\n\r\n/* Subtle animation when reaching end */\r\n.progress-fill:last-child {\r\n  animation: glow 0.6s ease-out;\r\n}\r\n\r\n@keyframes glow {\r\n  0%, 100% {\r\n    box-shadow: 0 0 12px var(--accent-primary);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 24px var(--accent-primary);\r\n  }\r\n}\r\n\r\n/* Mobile - slightly thicker for easier tap target awareness */\r\n@media (max-width: 768px) {\r\n  .reading-progress-bar {\r\n    height: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
